module.exports = __webpack_public_path__ + "static/media/GaetanoSchiratti.14676251.jpg";